/* eslint-disable indent */
import { token } from '@zillow/constellation';
import styled from 'styled-components';

import {
    Col,
} from '@zillow/zrs-comet';

// vars
const colMarginBottom = '18px';

export const StyledCol = styled(Col)`
    margin: 0 0 ${colMarginBottom} 0;
    padding: 0 8px;
    background-color: none;

    &:last-child {
        margin: 0;
    }

    /* 1023 */
    @media (min-width: ${token('breakpoints.xl') - 1}px) {
        margin: 0;
    }

    /* TODO: remove demo styles */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
`;
